import React, { useState, useEffect } from 'react';
import { Form, Button } from 'antd';
import CustomForm from 'src/components/CustomForm';
import { SETTINGS_FIELDS } from 'src/utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import settingActions from 'src/redux/actions/settingActions';
import settingSelectors from 'src/redux/selectors/settingSelectors';

const Settings = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const themeColor = useSelector(settingSelectors.themeColor);

  const initialValues = {
    themeColor
  };

  const onFinish = () => {
    const values = form.getFieldsValue();
    console.log(values);
    dispatch(settingActions.changeTheme(values.themeColor));
  };

  const setDefault = () => {
    form.setFieldValue('themeColor', '#001e38');
  };

  return (
    <div style={{ height: '100%', overflow: 'auto', paddingTop: 20 }}>
      <CustomForm form={form} fields={SETTINGS_FIELDS} autoComplete='off' layout='vertical' initialValues={initialValues} />
      <Button style={{ marginRight: 20 }} onClick={setDefault}>
        Default
      </Button>
      <Button type='primary' onClick={onFinish}>
        Save
      </Button>
    </div>
  )
}

export default Settings;